var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_170_8120)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0976 12.1234L11.6986 16.4426C11.3006 16.761 10.7267 16.7292 10.3663 16.3688L7.63091 13.6334C7.27046 13.273 7.23868 12.6991 7.55712 12.3011L11.8763 6.90206C13.8514 4.43325 16.8416 2.99609 20.0032 2.99609V2.99609C20.5557 2.99609 21.0036 3.444 21.0036 3.99651V3.99651C21.0036 7.15813 19.5664 10.1483 17.0976 12.1234Z",
    stroke: "#525866",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0011 13V17.3838C16.0011 17.7628 15.787 18.1092 15.4481 18.2786L13.0311 19.4871C12.7718 19.6168 12.4688 19.6276 12.2009 19.5166C11.933 19.4056 11.7264 19.1838 11.6347 18.9087L10.999 17.0017",
    stroke: "#525866",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99824 13.0001L5.09128 12.3645C4.81615 12.2728 4.59436 12.0662 4.48338 11.7982C4.3724 11.5303 4.38315 11.2274 4.51284 10.968L5.72134 8.55107C5.89079 8.21216 6.23717 7.99805 6.61608 7.99805H10.9999",
    stroke: "#525866",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.74734 20.5899L2.99609 21.0032L3.40942 18.252C3.5435 17.3595 4.24412 16.6589 5.13663 16.5248V16.5248C5.78158 16.4279 6.43424 16.6428 6.89541 17.104C7.35658 17.5651 7.57151 18.2178 7.4746 18.8628V18.8628C7.34049 19.7553 6.63985 20.4559 5.74734 20.5899V20.5899Z",
    stroke: "#525866",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_170_8120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/Rocket.6367c201d0decd09626a86a2234a34cc.svg";
export { ForwardRef as ReactComponent };